import { ThemeProvider } from "@emotion/react";
import { Route, Router } from "react-router-dom";
import { history } from "./utils/history";
import { ModalRouter } from "./components/ModalRouter";
import DocumentTitle from "react-document-title";
import config from "./utils/globalConfig";
import { useCookies } from "react-cookie";
import { store } from "./utils/store";
import { Provider } from "react-redux";
import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { loginRequest } from "./utils/authConfig";
import useResponsive from "./hooks/useResponsive";
import LandscapeOverly from "./components/LandscapeOverly/LandscapeOverly";
import { getLocalizedString } from "./utils";
import { theme } from "./styles/theme";
import ErrorBoundary from "./components/ErrorBonduary";
import Page500 from "./pages/500";
import GlobalServices from "./components/GlobalServices";

const ErrorComponent = () => (
  <div className="login-failed p-error">Login failed.</div>
);

const LoadingComponent = () => (
  <div className="card login-in-progress">Login in progress...</div>
);

const AppContent = () => {
  const [cookies] = useCookies(["cookie-name"]);
  const { orientation, type } = useResponsive();

  return (
    <DocumentTitle title={config.TITLE}>
      <Provider store={store}>
        <ThemeProvider {...{ theme }}>
          <ErrorBoundary fallback={<Page500 />}>
            <GlobalServices />
            <Router history={history}>
              <Route
                render={(routeProps) => {
                  const modalRoutProps = { ...routeProps };
                  return <ModalRouter {...modalRoutProps} cookies={cookies} />;
                }}
              />
            </Router>
            {type.mobile && !type.tablet && orientation === "landscape" ? (
              <LandscapeOverly text={getLocalizedString("ROTATE_MOBILE")} />
            ) : null}
          </ErrorBoundary>
        </ThemeProvider>
      </Provider>
    </DocumentTitle>
  );
};

function App() {
  console.log("VERSION: " + config.CODE_VERSION);

  let ssoLoginRequest = { ...loginRequest };

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={ssoLoginRequest}
      errorComponent={ErrorComponent}
      loadingComponent={LoadingComponent}
    >
      <AppContent />
    </MsalAuthenticationTemplate>
  );
}

export default App;
